module.exports = __webpack_public_path__ + "media/images/checkout/garantia-100-dias-7946c0727c7db430f4209094f7afabe7.png";